import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const CheckmarkBubbleIllustration = ({
  title,
  width = 40,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper
    marginLeft={marginLeft}
    marginRight={marginRight}
    containerSize={containerSize}
    title={title}
    width={width}
  >
    <svg viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5169_10940)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.2885 26.2141C33.0055 23.5621 34 20.4001 34 17.0001C34 7.60756 26.3925 6.10352e-05 17 6.10352e-05C7.6075 6.10352e-05 0 7.60756 0 17.0001C0 26.3926 7.6075 34.0001 17 34.0001C20.3915 34.0001 23.5535 33.0056 26.214 31.2886L34 34.0001L31.2885 26.2141Z"
          fill="#00396C"
        />
        <path
          opacity="0.1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 34.0001C20.3915 34.0001 23.5535 33.0056 26.214 31.2886L34 34.0001L31.2885 26.2141C33.0055 23.5621 34 20.4001 34 17.0001C34 7.60756 26.3925 6.10352e-05 17 6.10352e-05V34.0001Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.0774 10.9055C23.8169 10.0725 25.1004 10.0045 25.9249 10.7525C26.7154 11.458 26.8174 12.6395 26.1884 13.464L26.0779 13.6L16.1329 24.701C15.3679 25.551 14.0589 25.5935 13.2429 24.82L13.1239 24.701L7.93041 18.904C7.19091 18.071 7.25891 16.796 8.08341 16.0565C8.87391 15.351 10.0554 15.3765 10.8119 16.0905L10.9309 16.218L14.6199 20.3405L23.0604 10.9225L23.0774 10.9055Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_5169_10940">
          <rect width="34" height="34" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </DefaultIconWrapper>
);
